import { StripeConnectedAccountInfo } from '@flipdish/api-client-typescript';

/**
 * Stripe `disabled_reason` values meaning the account matched a third party prohibited
 * persons or companies list. Every other rejection reason keeps the generic message.
 */
const PROHIBITED_LIST_DISABLED_REASONS = ['rejected.listed', 'listed'];

/**
 * The API returns Stripe's `disabled_reason` as `DisabledReason`, but the generated client type does
 * not declare it. That client is gitignored and regenerated from Swagger on install, so it cannot be
 * patched here — the field is read through this type until codegen picks it up.
 */
type StripeConnectedAccountInfoWithDisabledReason = StripeConnectedAccountInfo & {
  DisabledReason?: string;
};

/** True only when the connected account was rejected for a prohibited persons/companies list match. */
export const isRejectedForProhibitedListMatch = (
  stripeAccount?: StripeConnectedAccountInfo
): boolean => {
  const { AccountStatus, DisabledReason } =
    (stripeAccount as StripeConnectedAccountInfoWithDisabledReason | undefined) ?? {};

  return (
    AccountStatus === StripeConnectedAccountInfo.AccountStatusEnum.Rejected &&
    PROHIBITED_LIST_DISABLED_REASONS.includes(DisabledReason ?? '')
  );
};

export const checkIsCompanyOnly = (selectedCountry?: string): boolean => {
  if (!selectedCountry) {
    return false;
  }
  const companyOnlyCountryCodes = ['AE'];
  return companyOnlyCountryCodes.some((charac) => selectedCountry.includes(charac));
};
